import { render, staticRenderFns } from "./ExchangeRateDateRuleFields.yaml?vue&type=template&id=720934f0&component"
import script from "./ExchangeRateDateRuleFields.yaml?vue&type=script&lang=ts&component"
export * from "./ExchangeRateDateRuleFields.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports